import {createSlice, PayloadAction, Slice} from '@reduxjs/toolkit';
import {defaultLocale} from "./locales";

export interface LocaleChange {
  localeKey: string | undefined;
}

export interface LocaleState extends LocaleChange {
  updated: boolean;
}

export const initialState: LocaleState = {
  updated: false,
  localeKey: defaultLocale,
};

const localeSlice: Slice<LocaleState> = createSlice({
  name: 'locale',
  initialState,
  reducers: {
    changeLocale: (state: LocaleState, action: PayloadAction<{ localeKey: string }>) => {
      state.updated = true
      state.localeKey = action.payload.localeKey || state.localeKey
    },
  },
});


export const {
  changeLocale,
} = localeSlice.actions;

export default localeSlice;
